<template>
  <div v-if="position" class="position-details-block">
    <!-- Link Entity + Ghana Flag Row -->
    <div class="position-main-row">
      <div class="position-entity-wrapper">
        <!-- Ghana Flag -->
        <ghana-flag
          :payload="ghanaFlagPayload"
          :eager_load="true"
          class="position-ghana-flag"
        />

        <!-- Link Entity Component -->
        <link-entity
          :payload="positionPayload"
          :additional_data="{ resource_type: 'Position' }"
        />
      </div>
    </div>

    <!-- Remark Warning (red alert) -->
    <div v-if="position.remark" class="position-remark-row">
      <div class="alert-note">
        <span>⚠️</span>
        <span>{{ position.remark }}</span>
      </div>
    </div>

    <!-- Message -->
    <div v-if="position.message" class="position-message-row clickable-message" @click="openMessageForm">
      <span class="info-label">massage:</span>
      <div class="message-text">{{ position.message }}</div>
    </div>

    <!-- Switch Button (for SolelBoneh) -->
    <div v-if="showSwitchButton" class="position-switch-row">
      <button
        @click="handleSwitchClick"
        class="button is-info is-small"
      >
        <span class="icon is-small">
          <i class="fas fa-exchange-alt"></i>
        </span>
        <span>החלף משרה</span>
      </button>
    </div>
  </div>
</template>

<script>
import LinkEntity from '@/components/LinkEntity.vue'
import GhanaFlag from '@/components/GhanaFlag.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'PositionDetailsBlock',
  components: {
    LinkEntity,
    GhanaFlag
  },
  props: {
    position: {
      type: Object,
      required: true
    },
    // Whether to show switch button (for SolelBoneh)
    showSwitchButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    positionPayload () {
      return {
        ...this.position,
        resource_type: 'Position',
        resource_id: this.position.id || this.position.resource_id
      }
    },
    ghanaFlagPayload () {
      return {
        ...this.position,
        resource_type: 'Position',
        resource_id: this.position.id || this.position.resource_id
      }
    }
  },
  methods: {
    handleSwitchClick () {
      this.$emit('switch-position')
    },
    openMessageForm () {
      if (!this.position) return

      this.create({
        designator: 'message-modal',
        component_name: 'MessageForm',
        resource_data: this.position,
        additional_data: {
          resource_type: 'Position',
          endpoint: 'positions',
          headers: 'admin_headers'
        },
        is_submitable: true,
        modal_title: 'Message - ' + (this.position.title || 'Position #' + this.position.id)
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>

<style scoped>
/* Unified Position Block Style */
.position-details-block {
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #667eea;
}

.position-main-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0;
  flex-wrap: nowrap;
}

.position-entity-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
  flex: 0 1 auto;
}

.position-remark-row,
.position-message-row {
  padding: 0;
  margin-top: 0.2rem;
}

.position-switch-row {
  padding: 0;
  margin-top: 0.2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

/* Alert Note (Red Warning) */
.alert-note {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.6rem;
  background: #ffe5e5;
  border: 1px solid #ff4444;
  border-radius: 4px;
  color: #cc0000;
  font-weight: 600;
  font-size: 0.85rem;
  width: 100%;
}

/* Message */
.position-message-row {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.info-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.85rem;
  text-align: right;
  align-self: flex-end;
}

.message-text {
  background: #ffffff;
  padding: 0.4rem 0.6rem;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  font-size: 0.85rem;
  line-height: 1.4;
  word-break: break-word;
  width: 100%;
}

/* Icons alignment to the right */
.position-main-row :deep(.operations),
.position-main-row :deep(.icons-wrapper),
.position-entity-wrapper :deep(.operations),
.position-entity-wrapper :deep(.icons-wrapper) {
  margin-left: auto;
  display: flex;
  gap: 0.3rem;
  align-items: center;
  flex-shrink: 0;
}

/* Ensure content wraps properly */
.position-details-block :deep(*) {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Fix icon sizing - prevent icons from expanding */
.position-details-block :deep(.operation_icon),
.position-details-block :deep(img.operation_icon) {
  max-width: 18px !important;
  width: 18px !important;
  height: auto !important;
}

/* Clickable Message */
.clickable-message {
  cursor: pointer;
}

.clickable-message:hover {
  background-color: #e8f4f8 !important;
  border-radius: 4px;
}
</style>
